// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"189":"10de37e5e4ddb82cd643","364":"db6f0513c83ce3621474"}[chunkId] + ".js";
};